<template>
  <general-layout clean :resizable="false">
    <template v-slot:header>
      <a-tree-select
        v-model="currentStationGroupIds"
        style="width: 400px"
        :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
        :treeData="stationGroupList"
        :alowClear="allowClear"
        placeholder="请选择"
        treeDefaultExpandAll
        treeDataSimpleMode
        multiple
        tree-node-filter-prop="title"
      />
    </template>
    <template v-slot:right>
      <div style="height: calc(100% - 40px); overflow-y: auto; overflow-x: hidden">
        <a-spin
          v-show="loading"
          size="large"
          style="width: 100%; height: 800px; text-align: center; line-height: 800px"
        />
        <!-- <a-row v-show="!loading" :gutter="16" style="height: 100%;"> -->

          <template v-if="cardList.length">
            <waterfall
                :col="3"
                :data="cardList"
                :lazy-distance="20"
                :load-distance="300"
                :gutterWidth="gutterWidth"
              >
            <a-col v-for="(item, index) in cardList" :key="index" :offset="1" >
              <StatusCard :key="item.id" :statusDict="statusDict" :record="item" @refresh="refresh" />
            </a-col>
           </waterfall>
          </template>

          <template v-else>
            <a-empty class="mt-16"></a-empty>
          </template>
        <!-- </a-row> -->
      </div>
      <div style="text-align: right; padding-top: 8px;">
        <a-pagination v-model="currentPage" :pageSize="9" :total="total" show-less-items :showTotal="total => `${totalFanyi(total)}`"/>
      </div>
    </template>
  </general-layout>
</template>

<script>
import StatusCard from './components/StatusCard'
import { wsgsp, wsrtssp, ws, tssp } from './service'
import { getUserInfo } from '@/utils/auth'
import {
  transformArgToKey,
  generateLocalArgsList
} from './utils'
import i18n from '@/locales/index'
import { WorkStationWcsSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const wswssp = new WorkStationWcsSettingServiceProxy()

const statusDict = {
  0: { name: i18n.t('page_mdc_realtime_status_unknown'), color: '#ddd', en: 'Unknown' },
  1: {
    name: i18n.t('page_mdc_realtime_status_alarm'),
    color: '#FA554C',
    en: 'Alarm_and_malfunction'
  },
  2: {
    name: i18n.t('page_mdc_realtime_status_manual_wait'),
    color: '#E1A400',
    en: 'Manual_mode_idle'
  },
  3: { name: i18n.t('page_mdc_realtime_status_auto_wait'), color: '#FDBB08', en: 'Auto_mode_idle' },
  4: {
    name: i18n.t('page_mdc_realtime_status_other_wait'),
    color: '#E2CB00',
    en: 'Other_mode_idle'
  },
  5: {
    name: i18n.t('page_mdc_realtime_status_manual_run'),
    color: '#2A9F0C',
    en: 'Manual_mode_running'
  },
  6: {
    name: i18n.t('page_mdc_realtime_status_auto_run'),
    color: '#7ED321',
    en: 'Auto_mode_running'
  },
  7: {
    name: i18n.t('page_mdc_realtime_status_other_run'),
    color: '#ABDE2F',
    en: 'Other_mode_running'
  },
  8: { name: i18n.t('page_mdc_realtime_status_off'), color: '#E0E0E0', en: 'offline' },
  9: { name: i18n.t('page_mdc_realtime_status_down'), color: '#B4B4B4', en: 'network_down' },
  10: { name: i18n.t('page_mdc_realtime_status_mdi'), color: '#37a002', en: 'MDI' }
}

export default {
  components: {
    StatusCard,
  },
  data() {
    return {
      cardList: [],
      stationGroupList: [],
      currentStationGroupIds: [],
      iotPaths: [],
      loading: true,
      allowClear: false,
      currentPage: 1,
      total: 0,
      statusDict,
    }
  },
  watch: {
    currentStationGroupIds: {
      async handler(ids) {
        ws.loading.next(true)
        this.currentPage = 1
        setTimeout(() => {
          if (ws.loading.value) {
            ws.loading.next(false)
          }
        }, 3000)
        const tenantId = this.getTenantId()
        if (ws.readyState === 1 && this.iotPaths.length > 0) {
          ws.unsubscribe(this.iotPaths)
        }
        if (!ids || ids.length === 0) {
          this.cardList = []
          this.iotPaths = []
          this.total = 0
          return
        }
        const helper = (array, id, res = []) => {
          const children = array.filter((item) => item.pId === id)
          if (children.length > 0) {
            children.forEach((item) => {
              res.push(item.id)
              helper(array, item.id, res)
            })
          }
          return res
        }

        // const target = helper(this.stationGroupList, id, [id])
        this.total = 0
        const target = ids.flatMap((id) => helper(this.stationGroupList, id, [id]))
        const res = await wsrtssp.getRealTimeStatus(
          this.currentPage,
          { workStationGroupIdList: target },
          9
        )
        this.total = res.total
        // 去重
        const temp = []
        res.records.forEach((re) => {
          const index = temp.findIndex((tem) => tem.id === re.id)
          if (index < 0) {
            temp.push(re)
          }
        })
        this.cardList = temp
        this.iotPaths = temp
          .filter(
            (item) =>
              item.workingConditionSettingVOList && item.workingConditionSettingVOList.length > 0
          )
          .flatMap((item) => item.workingConditionSettingVOList)
          .map((item) => `${tenantId}/${item.iotId}/${item.iotAppId}/#`)

        await this.fetchDetail()

        if (!tenantId) return

        if (this.iotPaths.length > 0) {
          ws.subscribe(Array.from(new Set(this.iotPaths)))
        }
        ws.loading.next(false)
      }
    },
    currentPage: {
      async handler(val) {
        ws.loading.next(true)
        setTimeout(() => {
          if (ws.loading.value) {
            ws.loading.next(false)
          }
        }, 3000)
        const tenantId = this.getTenantId()
        if (ws.readyState === 1 && this.iotPaths.length > 0) {
          ws.unsubscribe(this.iotPaths)
        }
        if (!this.currentStationGroupIds || this.currentStationGroupIds.length === 0) {
          this.cardList = []
          this.iotPaths = []
          return
        }
        const helper = (array, id, res = []) => {
          const children = array.filter((item) => item.pId === id)
          if (children.length > 0) {
            children.forEach((item) => {
              res.push(item.id)
              helper(array, item.id, res)
            })
          }
          return res
        }
        // const target = helper(this.stationGroupList, id, [id])
        this.total = 0
        const target = this.currentStationGroupIds.flatMap((id) =>
          helper(this.stationGroupList, id, [id])
        )
        const res = await wsrtssp.getRealTimeStatus(val, { workStationGroupIdList: target }, 9)
        this.total = res.total
        // 去重
        const temp = []
        res.records.forEach((re) => {
          const index = temp.findIndex((tem) => tem.id === re.id)
          if (index < 0) {
            temp.push(re)
          }
        })
        this.cardList = temp
        this.iotPaths = temp
          .filter(
            (item) =>
              item.workingConditionSettingVOList && item.workingConditionSettingVOList.length > 0
          )
          .flatMap((item) => item.workingConditionSettingVOList)
          .map((item) => `${tenantId}/${item.iotId}/${item.iotAppId}/#`)

        await this.fetchDetail()

        if (!tenantId) return

        if (this.iotPaths.length > 0) {
          ws.subscribe(Array.from(new Set(this.iotPaths)))
        }
        ws.loading.next(false)
      }
    }
  },
  computed:{
itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    },
  },
  created() {
    this.getDict()
    ws.loading.subscribe(async (val) => {
      await this.$nextTick()
      this.loading = val
    })

    ws.open()
    this.$once('hook:beforeDestroy', () => {
      ws.close()
    })
    this.$once('hook:deactivated', () => {
      ws.close()
    })
    this.fetchStationGroupList()
  },
  methods: {
    async getDict() {
      let res = await wswssp.getWorkStationWcsSettingList()
      let temp = { 0: this.statusDict[0] }
      res.map(item => {
        temp[item.code] = item
      })
      this.statusDict = temp
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    getTenantId() {
      const info = getUserInfo()
      return info.tenant_id || ''
    },
    async fetchStationGroupList() {
      const res = await wsgsp.list()
      const helper = (array, pId, res = []) => {
        const children = array.find((item) => item.id === pId)
        if (children) {
          res.unshift(children.name)
          return helper(array, children.parentId, res)
        } else {
          return res.join('/')
        }
      }
      this.stationGroupList = res.workStationGroupDTOList.map((item) => ({
        id: item.id,
        pId: item.parentId,
        value: item.id,
        label: helper(res.workStationGroupDTOList, item.parentId, [item.name])
      }))
      // this.stationGroupList = []
      this.currentStationGroupIds = this.stationGroupList[0] && [this.stationGroupList[0].id]
    },
    async refresh() {
      ws.loading.next(true)
      setTimeout(() => {
        if (ws.loading.value) {
          ws.loading.next(false)
        }
      }, 3000)
      const tenantId = this.getTenantId()
      this.cardList = []
      await this.$nextTick()
      const ids = this.currentStationGroupIds
      if (ws.readyState === 1 && this.iotPaths.length > 0) {
        ws.unsubscribe(this.iotPaths)
      }
      const helper = (array, id, res = []) => {
        const children = array.filter((item) => item.pId === id)
        if (children.length > 0) {
          children.forEach((item) => {
            res.push(item.id)
            helper(array, item.id, res)
          })
        }
        return res
      }
      // const target = helper(this.stationGroupList, id, [id])
      this.total = 0
      const target = ids.flatMap((id) => helper(this.stationGroupList, id, [id]))
      const res = await wsrtssp.getRealTimeStatus(
        this.currentPage,
        { workStationGroupIdList: target },
        9
      )
      this.total = res.total
      // 去重
      const temp = []
      res.records.forEach((re) => {
        const index = temp.findIndex((tem) => tem.id === re.id)
        if (index < 0) {
          temp.push(re)
        }
      })
      this.cardList = temp
      this.iotPaths = temp
        .filter(
          (item) =>
            item.workingConditionSettingVOList && item.workingConditionSettingVOList.length > 0
        )
        .flatMap((item) => item.workingConditionSettingVOList)
        .map((item) => `${tenantId}/${item.iotId}/${item.iotAppId}/#`)

      await this.fetchDetail()

      if (!tenantId) return

      if (this.iotPaths.length > 0) {
        ws.subscribe(Array.from(new Set(this.iotPaths)))
      }
      ws.loading.next(false)
    },
    async fetchDetail() {
      const tenantId = this.getTenantId()
      const ids = this.cardList.reduce((prev, curr) => prev + curr.id + ',', '')
      console.log(ids)
      try {
        const res = await tssp.detailConditions(ids, 'workStation-property-setting')
        this.cardList.forEach((item) => {
          const target = res.find((ite) => ite.paramKey === item.id)
          const detail = target || { paramValue: null }
          const tagsList = generateLocalArgsList(
            JSON.parse(detail.paramValue) || [[], [], []],
            item.workingConditionSettingVOList || []
          )
          const statusKeys = transformArgToKey(tagsList, tenantId)
          this.$set(item, 'detail', detail)
          this.$set(item, 'tagsList', tagsList)
          this.$set(item, 'statusKeys', statusKeys)
        })
      } finally {
      }
    }
  }
}
</script>

<style lang="less">
// @import 'index.less';
</style>
